import { FileText } from "lucide-react";
import Markdown from "@/components/Markdown";
import { attachmentFromMessage, fileKind } from "@/lib/attach";

export default function MessageBubble({ message, maxWidth = "max-w-[85%]" }) {
  const isUser = message.role === "user";
  const content = message.content || "";
  const attachment = attachmentFromMessage(message);

  if (message.role === "system" && !attachment) return null;

  return (
    <div
      data-testid={`message-${message.role}`}
      className={`flex ${isUser ? "justify-end" : "justify-start"}`}
    >
      {attachment ? (
        <div
          data-testid="attachment-chip"
          className="inline-flex items-center gap-2.5 rounded-2xl border border-brand-sage/40 bg-brand-sage/10 px-4 py-3 text-[13.5px] font-ui text-brand-sage"
        >
          <FileText className="w-4 h-4 shrink-0" />
          <span className="min-w-0">
            <span className="block truncate max-w-[240px] text-brand-ink">{attachment.filename}</span>
            <span className="text-[11px] text-brand-sage/80">
              {fileKind(attachment.filename)} · lido
              {attachment.truncated ? " · cortado" : ""}
            </span>
          </span>
        </div>
      ) : (
        <div
          className={`${maxWidth} rounded-2xl px-4 py-3 text-[15px] leading-relaxed ${
            isUser
              ? "bg-brand-rose text-brand-bg rounded-br-md font-medium"
              : "bg-brand-elevated text-white border border-brand-line rounded-bl-md"
          }`}
        >
          {isUser ? (
            <pre className="whitespace-pre-wrap break-words font-sans">{content}</pre>
          ) : content ? (
            <Markdown text={content} className="markdown-bubble" />
          ) : (
            <span className="text-brand-ink2">...</span>
          )}
        </div>
      )}
    </div>
  );
}
